(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Product_tr', Product_tr);

    Product_tr.$inject = ['$resource'];

    function Product_tr ($resource) {
        var resourceUrl =  'api/product-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
